export default "__VITE_ASSET__BCGV2nGt__"